import axios from 'axios'
import * as types from '../mutation-types'

const doToArrayObject = typeContracts => {
  const term = []
  Object.keys(typeContracts).forEach(key => {
    term.push({
      value: typeContracts[key].id,
      text: typeContracts[key].name,
      selected: typeContracts[key].selected || false,
    })
  })

  return term
}

// state
export const state = {
  loading: true,
  typeContracts: [],
  error: null,
}

// mutations
export const mutations = {
  [types.GET_TYPE_CONTRACT_START] (state) {
    state.loading = true
    state.typeContracts = []
    state.error = null
  },

  [types.GET_TYPE_CONTRACT_SUCCESS] (state, { data }) {
    state.loading = false
    state.typeContracts = doToArrayObject(data)
    state.error = null
  },

  [types.GET_TYPE_CONTRACT_ERROR] (state, { error }) {
    state.loading = false
    state.typeContracts = []
    state.error = error
  },
}

export const actions = {
  async getTypeContracts ({ commit }) {
    try {
      commit(types.GET_TYPE_CONTRACT_START)

      const { data } = await axios.get('/api/tipo_contratos/list')

      commit(types.GET_TYPE_CONTRACT_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_TYPE_CONTRACT_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingTypeContract: state => state.loading,
  typeContracts: state => state.typeContracts,
  errorTypeContract: state => state.error,
}
